export type ProcessRunningModalProps = {}

type DefaultProcessRunningModalProps = {}

export const defaultProps: DefaultProcessRunningModalProps = {}
